<template>
	<div class="wrapper">
		<headerTag />
		<van-list
			   :immediate-check="false"
			  v-model="loading"
			  :finished="finished"
			  finished-text="没有更多了"
			   @load="onLoad"
			    v-show="!notFoundShow"
			>
			<div class="twDiv twDiv1">
				<router-link :to="{ name:'wenDetail', params: {id: item.id} }" v-for="item in list">
						<p class="twDiv-p1">
							{{item.title}}
						</p>
				</router-link>
			</div>
		</van-list>
		
		<notFound v-show="notFoundShow"/>
		
		<footerTag />
	</div>

</template>

<script>
   
    import "../../assets/css/user.scss"
    import headerTag from '@/components/headerTag/headerTag.vue'
    import footerTag from '@/components/footerTag/footerTag.vue'
    import notFound from '@/components/notFound/notFound.vue'
    import { List } from 'vant'
    
    export default {
    	name: 'mineTiwen',
    	props: {
        
    	},
    	data:function(){
		  return {
		    list: [],
		    loading: false,
		    finished: false,
			page:1,
			limit:10,
			total:'',
			notFoundShow:false,
		  }
		},
    	components: {
    		headerTag,
    		footerTag,
    		notFound,
    		[List.name]:List
    	},
    	methods: {
			 loadAsks(){
			 	this.axios({
			 	    method: 'POST',
			 	    url:'/feedback/getAsks',
			 		params:{
			 			page:this.page,
			 			limit:this.limit
			 		},
			 	}).then((res)=>{
			 			console.log(111);
			 			if(res.data.code==1000){
			 				let data = res.data.data;
							this.list=this.list.concat(data.list); 
							this.total=data.total;
							if(this.total == 0){
								this.notFoundShow=true;
							}else{
								this.notFoundShow=false;
							}
			 			}else if(res.data.code == 1110){
				  			//未登录
				  			let currPath=window.location.href;
				  			window.location.href='/login?targetUrl='+currPath;
			  			}else{	
			  				this.$message.error({message: '网络异常，请稍后重试'});
			  			}
			 	}).catch((err)=>{
			 		 this.$message.error({message: '获取数据失败'});
			 	})
			 },
			onLoad() {
			       // 异步更新数据
			       setTimeout(() => {
					 this.page++;
					 this.loadAsks();
			         // 加载状态结束
			         this.loading = false;
			         // 数据全部加载完成
					  if (this.list.length >= this.total) {
					        this.finished = true;
					    }
			       }, 500);
			   },
		},
    	created(){
			this.loadAsks();
		} 
    }
</script>